import React, { useCallback, useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { GradientBackground } from './components/index';
import { router } from './Routes';
import { AuthProvider } from './module/AuthenticationModule';
import GlobalFonts from './asset/fonts/font';
import { useThemeContext } from './hook/useThemeManager';
import { ColorScheme, theme } from './constants/theme';
import { toggleTheme } from './redux/appConfigurator/action';
import { useDispatch } from 'react-redux';
import { AuthModal } from './components/AuthModal/AuthModal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const dispatch = useDispatch();

    const handleSetTheme = useCallback(() => {
        const isSet = localStorage.getItem('theme_toggled');
        if (mediaQuery.matches && !isSet) {
            dispatch(toggleTheme(mediaQuery.matches ? 'dark' : 'light'));
        }
    }, [mediaQuery.matches, dispatch]);

    useEffect(() => {
        handleSetTheme();
    }, [handleSetTheme]);

    return (
        <GradientBackground style={styles.container}>
            <AuthProvider>
                <View style={styles.wrapper}>
                    <GlobalFonts />
                    <RouterProvider router={router} />
                    <AuthModal />
                    <ToastContainer position="bottom-right" />
                </View>
            </AuthProvider>
        </GradientBackground>
    );
}

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        container: {
            flex: 1,
            alignItems: 'center',
            width: '100%',
            justifyContent: 'center',
            height: '100%',
            backgroundColor: theme[colorScheme].pure_black,
        },
        wrapper: {
            alignContent: 'center',
            flex: 1,
            overflow: 'hidden',
        },
    });

export default App;
